import { createTheme } from "@mui/material/styles";
import palette from "./palette";

const spacing = (factor: number) => `${factor * 8}px`;

const breakpoints = {
  values: {
    xs: 390,
    sm: 540,
    md: 768,
    lg: 1200,
    xl: 1440,
  },
};

const theme = createTheme({
  spacing,
  breakpoints: breakpoints,
  palette: palette,
  components: {
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: palette.grey[600],
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        message: {
          width: "100%",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: "Inter",
          fontSize: 13,
          fontWeight: 600,
          color: palette.grey[600],
          "&:hover": {
            backgroundColor: palette.grey[200],
            color: palette.primary.main,
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "inter",
          color: palette.grey[700],
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: "#6e7f91",
          opacity: "100",
          width: "163px",
          height: "40px",
          textTransform: "none",
          fontWeight: "600",
          fontFamily: "Inter",
          fontSize: 13,
          borderBottom: "1px solid #dbe2e9",
          background: "#eff3f7",
          "&.Mui-selected": {
            backgroundColor: "#B8FBF0",
            color: palette.primary.main,
          },
        },
      },
    },
    MuiButton: {
      defaultProps: {
        size: "large",
      },
      styleOverrides: {
        root: {
          fontFamily: "Inter",
          fontWeight: 600,
          textTransform: "none",
          boxShadow: "none",
        },
        outlinedPrimary: {
          color: palette.primary.main,
          borderColor: palette.primary.main,
        },
        icon: {
          color: "currentColor",
        },
        contained: {
          boxShadow: "none",
          borderWidth: 2,
          "&:hover": {
            boxShadow: "none",
          },
        },
        outlined: {
          boxShadow: "none",
          borderWidth: 2,
          "&:hover": {
            boxShadow: "none",
            borderWidth: 2,
          },
        },
      },
    },
  },
});

export default theme;
